import React from 'react';
import moment from 'moment';
import { FormComponentProps } from 'antd/lib/form';
import { Form, Row, Col, DatePicker, InputNumber, Select, Input, Button, Checkbox, Radio, Collapse, Icon } from 'antd';
import { TransformType } from 'kts-platform-frame/entry/constant';
import Language from 'kts-platform-frame/entry/Language';
import { withRouter } from 'kts-platform-frame/routes';
const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const Panel = Collapse.Panel;
const css = require('./index.scss');
interface UserFormProps extends FormComponentProps {

}
interface IProps extends UserFormProps {
    fields: any;
    clearFields: () => void;
    onValuesChange: (values: Array<any>) => void;
    onAddToGroup?: () => void;
    getData: () => void;
    //history:any;
}
@withRouter
class Component extends React.Component<IProps, any> {
    private myform: any;
    /**
     * 高级搜索
     * @param {*} props 
     */
    private invoiceStateOption = [
        { label: '正常', value: 'NORMAL' },
        { label: '作废', value: 'CANCELLED' },
        { label: '异常', value: 'ABNORMAL' },
        { label: '失控', value: 'UNCONTROLLED' },
        { label: '红冲', value: 'RED' },
        { label: '部分冲红', value: 'PART_RED' },
        { label: '全额冲红', value: 'ALL_RED' },

    ];
    private invoiceTypeOption = [
        { label: Language.transformTypeStringShort(TransformType.增值税专用发票), value: TransformType.增值税专用发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税电子专用发票), value: TransformType.增值税电子专用发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税普通发票INVOICE), value: TransformType.增值税普通发票INVOICE },
        { label: Language.transformTypeStringShort(TransformType.机动车销售统一发票), value: TransformType.机动车销售统一发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税电子普通发票), value: TransformType.增值税电子普通发票 },
        { label: Language.transformTypeStringShort(TransformType.增值税普通发票卷票), value: TransformType.增值税普通发票卷票 },
        { label: Language.transformTypeStringShort(TransformType.二手车销售统一发票), value: TransformType.二手车销售统一发票 },
        { label: Language.transformTypeStringShort(TransformType.通行费发票), value: TransformType.通行费发票 },
        { label: Language.transformTypeStringShort(TransformType.全电专票), value: TransformType.全电专票 },
        { label: Language.transformTypeStringShort(TransformType.全电普票), value: TransformType.全电普票 },
    ];
    private options2 = [
        { label: '全选', value: null },
        { label: '未提交', value: '0' },
        { label: '已提交', value: '1' },
    ];
    private optionsMatchState = [
        { label: '全部', value: null },
        { label: '匹配成功', value: 1 },
        { label: '匹配中', value: 0 },
    ];
    private unusualStateOption = [
        { label: '正常', value: 'NORMAL' },
        { label: '异常', value: 'UNUSUAL' },
        { label: '提示', value: 'WARN' },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            expand: false
        };
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    }

    handleReset = () => {
        this.props.clearFields();
        this.props.form.resetFields();
    }
    onAddToGroup = () => {
        this.props.onAddToGroup();
    }
    toggle = () => {
        const { expand } = this.state;
        this.setState({ expand: !expand });
    }
    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.getData();
                //this.props.history.push('invoiceInput');
            }

        });
    }
    creatPanelHeader = (str) => {
        return (
            <div>{str}<Icon type="bars" /></div>
        );
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 24 },
            style: { marginBottom: 0 }
        };
        const customPanelStyle = {
            marginBottom: 8,
            border: 0,
        };
        return (

            <Form
                ref={(target) => { this.myform = target; }}
                onSubmit={this.handleSearch}
                className="panel-collapse"
            >
                <Collapse accordion={true} bordered={false}>
                    <Panel showArrow={false} header='发票代码' key="1" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('invoiceCode')(
                                <Input />
                            )}
                        </FormItem>
                    </Panel>

                    <Panel showArrow={false} header="发票号码" key="2" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('invoiceNumber')(
                                <Input />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="销售方" key="3" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('supplierName')(
                                <Input placeholder="支持模糊搜索" />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="开票日期" key="4" style={customPanelStyle}>
                        <FormItem  {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('minInvoiceDate')(
                                        <DatePicker style={{ width: '100%' }} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                    -
                            </span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('maxInvoiceDate')(
                                        <DatePicker style={{ width: '100%' }} />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="价税合计" key="5" style={customPanelStyle}>
                        <FormItem  {...formItemLayout} >
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('minAmount')(
                                        <InputNumber style={{ width: '100%' }} precision={2} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                    -
                            </span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('maxAmount')(
                                        <InputNumber style={{ width: '100%' }} precision={2} />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="查验状态" key="6" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('unusualState')(
                                <CheckboxGroup options={this.unusualStateOption} />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="录入用户" key="7" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('userType')(
                                <Radio.Group >
                                    <Radio value={null}>全部用户</Radio>
                                    <Radio value={1}>当前用户</Radio>

                                </Radio.Group>
                            )}
                        </FormItem>
                    </Panel>

                    <Panel showArrow={false} header="发票类型" key="8" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('invoiceType')(
                                <Select mode="multiple" >
                                    {this.invoiceTypeOption.map(d => <Option key={d.value}>{d.label}</Option>)}
                                </Select>
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="发票状态" key="9" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator("invoiceState")(
                                <CheckboxGroup options={this.invoiceStateOption} />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="录入时间" key="10" style={customPanelStyle}>
                        <FormItem  {...formItemLayout}>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('minLoggedDate')(
                                        <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={2}>
                                <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                    -
                            </span>
                            </Col>
                            <Col span={11}>
                                <FormItem>
                                    {getFieldDecorator('maxLoggedDate')(
                                        <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }} />
                                    )}
                                </FormItem>
                            </Col>
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="提交状态" key="12" style={customPanelStyle}>
                        <FormItem {...formItemLayout}>
                            {getFieldDecorator('isNotionalPooling')(
                                <RadioGroup options={this.options2} />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header='发票组编号' key="11" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('groupNumber')(
                                <Input />
                            )}
                        </FormItem>
                    </Panel>
                    <Panel showArrow={false} header="发票组匹配状态" key="15" style={customPanelStyle}>
                        <FormItem {...formItemLayout} >
                            {getFieldDecorator('groupMatchState')(
                                <Radio.Group options={this.optionsMatchState}>


                                </Radio.Group>
                            )}
                        </FormItem>
                    </Panel>
                    <Col span={24} className="mb10 ">
                        <Button
                            type="primary"
                            className={`mr10 pull-right ${css['invoice-card-but31']} ${css['invoice-card-but-width62']}`}
                            htmlType="submit"
                        >
                            筛选
                        </Button>
                        <Button
                            className={`mr10 pull-right ${css['invoice-card-but31']} ${css['invoice-card-but-width62']}`}
                            onClick={this.handleReset}
                        >
                            清空
                        </Button>
                    </Col>
                </Collapse>
            </Form>

        );
    }
}
const WrappedAdvancedSearchForm = Form.create({
    mapPropsToFields(props: IProps) {
        return {
            supplierName:
                Form.createFormField({ value: props.fields && props.fields.supplierName })
            ,
            invoiceCode:
                Form.createFormField({ value: props.fields && props.fields.invoiceCode })
            ,
            invoiceNumber:
                Form.createFormField({ value: props.fields && props.fields.invoiceNumber })
            ,
            userType:
                Form.createFormField({ value: props.fields && props.fields.userType })
            ,
            invoiceType:
                Form.createFormField({ value: props.fields && props.fields.invoiceType })
            ,
            unusualState:
                Form.createFormField({ value: props.fields && props.fields.unusualState })
            ,
            minInvoiceDate:
                Form.createFormField({ value: props.fields && (props.fields.minInvoiceDate && moment(props.fields.minInvoiceDate)) })
            ,
            maxInvoiceDate:
                Form.createFormField({ value: props.fields && (props.fields.maxInvoiceDate && moment(props.fields.maxInvoiceDate)) })
            ,
            minAmount:
                Form.createFormField({ value: props.fields && props.fields.minAmount })
            ,
            maxAmount:
                Form.createFormField({ value: props.fields && props.fields.maxAmount })
            ,
            minLoggedDate:
                Form.createFormField({ value: props.fields && props.fields.minLoggedDate })
            ,
            maxLoggedDate:
                Form.createFormField({ value: props.fields && props.fields.maxLoggedDate })
            ,
            invoiceState:
                Form.createFormField({ value: props.fields && props.fields.invoiceState })
            ,
            isNotionalPooling:
                Form.createFormField({ value: props.fields && props.fields.isNotionalPooling })
            ,
            groupNumber:
                Form.createFormField({ value: props.fields && props.fields.groupNumber })
            ,
            groupMatchState:
                Form.createFormField({ value: props.fields && props.fields.groupMatchState })
        };
    },
    onValuesChange(props: IProps, values: Array<any>) {
        props.onValuesChange(values);
    },
})(Component);
export default WrappedAdvancedSearchForm;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/AdvancedForm.tsx